module.exports = __webpack_public_path__ + "static/media/dnd-icon.f65b2a94.svg";